namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_quick2, {
		
		background: {
			color: $mol_theme.back,
		},
		boxShadow: '0 0 1rem hsla(0,0%,0%,.5)',
		border: {
			radius: $mol_gap.round,
		},
		position: 'relative',
		height: '2.5rem',
		'[shm_hitalama_quick2_vertical]': {
			true: {
				height: 'auto',
			},
		},

		Panel: {
			background: {
				color: $mol_theme.card,
			},
			border: {
				radius: $mol_gap.round,
			},
			pointerEvents: 'auto',
			'[shm_hitalama_quick2_vertical]': {
				true: {
					flex: {
						direction: 'column',
					},
				},
			},
		},

		Button: {
			background: {
				color: $mol_theme.card,
			},
			boxShadow: 'inset 0 0 0 1px var(--mol_theme_field)',
			justify: {
				content: 'center',
			},
			font: {
				size: '20px',
			},
			width: '3rem',
			position: 'relative',
			'[mol_check_checked]': {
				true: {
					outline: '2px solid var(--mol_theme_current) !important',
				},
			},
		},

		Speck: {
			padding: 0,
			position: 'absolute',
			left: '0.3rem',
			top: '-0.2rem',
			background: {
				color: 'transparent',
			},
			font: {
				size: '12px',
			},
		},

		Hovered_title: {
			background: {
				color: $mol_theme.back,
			},
			position: 'absolute',
			left: '50%',
			top: '-2rem',
			transform: 'translateX(-50%)',
			whiteSpace: 'nowrap',
		},
		
	} )
	
}
